import { PreContractActions } from "../actions";

const initialState = {
  preContracts: {
    rows: [],
    rowCount: 1,
    pageCount: 1,
  },
};

export default function preContract(state = initialState, action) {
  switch (action.type) {
    case PreContractActions.ACTION_SAVE_PRECONTRACTS:
      return {
        ...state,
        preContracts: action.payload,
      };
    default:
      return state;
  }
}

export function getPreContracts(state) {
  return state.preContract.preContracts;
}
